import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-8W0HP42T3L';
let gaInitialized = false;

const sendPageView = (path, title, location) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title,
      page_location: location,
    });
  }
};

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (gaInitialized) return;
    ReactGA.initialize(MEASUREMENT_ID, { gtagOptions: { send_page_view: false } });
    gaInitialized = true;
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    sendPageView(path, document.title, window.location.href);
  }, [location]);

  return null;
};

export default Analytics;


